module.exports = __webpack_public_path__ + "img/barracuda.633193e5.jpg";